import { http } from "../_apiConfig/http";
import { RouteUrls } from "../_apiConfig/routeUrls";

export const FloorMapService = {
  AddDevicePosition, getDeviceWithSensor, getFloorDetails, registerFloor, updateFloor, getFloorList,
  getSingleFloor,getFloorsBySite
};

function AddDevicePosition(id, data) {
  return http.update(`${RouteUrls.FloorMapAddDevice}/${id}`, data, true);
}

function getDeviceWithSensor(data) {
  return http.post(`${RouteUrls.DeviceWithSensor}`, data, true);
}

function getFloorDetails(floorId) {
  return http.get(`${RouteUrls.getFloorList}/${floorId}`, true);
}

function registerFloor(data) {
  return http.post(`${RouteUrls.getFloorList}`, data, true);
}

function updateFloor(floorId, data) {
  return http.update(`${RouteUrls.getFloorList}/${floorId}`, data, true);
}

function getFloorList(page, limit, status) {
  return http.get(
    `${RouteUrls.getFloorList}?page=${page}&limit=${limit}&status=${status}`,
    true
  );
}

function getSingleFloor(gatewayMac) {
  return http.get(
    `${RouteUrls.getFloorList}/location/${encodeURIComponent(gatewayMac)}`,
    true
  );
}

function getFloorsBySite(page, limit, siteId) {
  return http.get(
    `${RouteUrls.getFloorList}/site/${siteId}?page=${page}&limit=${limit}`,
    true
  );
}
